import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const MultilineChart = () => {
  const [series] = useState([
    {
      name: "Basic",
      data: [2, 12, 5, 3, 4, 6, 7, 8, 6, 5, 6, 5, 4],
    },
    {
      name: "Premium",
      data: [12, 4, 5, 8, 7, 8, 7, 6, 7, 8, 9, 10],
    },
    {
      name: "Unlimited",
      data: [9, 6, 7, 10, 9, 10, 9, 8, 8, 9, 10, 11, 12],
    },
  ]);

  const [options] = useState({
    chart: {
      type: "line",
      height: 350,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "smooth", // To make the line smooth like in the image
      width: 6, // Adjust thickness to match the line in the image
      colors: ["#34B3F1", "#292D30", "#143A62"],
      dropShadow: {
        enabled: true,
        top: 5, // Vertical offset of the shadow
        left: 0, // Horizontal offset of the shadow
        blur: 10, // Blurriness of the shadow
        opacity: 0.9, // Opacity of the shadow
        color: "#0052CC", // Shadow color, similar to line color
      },
    },
    colors: ["#34B3F1", "#292D30", "#143A62"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.9,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    xaxis: {
      categories: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ],
      labels: {
        style: {
          colors: "#143A62",
          fontSize: "14px",
        },
      },
    },
    yaxis: {
      min: 0,
      max: 12,
      tickAmount: 6,
      labels: {
        style: {
          colors: "#143A62",
          fontSize: "14px",
        },
        formatter: function (val) {
          return val.toFixed(0);
        },
      },
    },
    grid: {
      borderColor: "#C9CBCD",
      strokeDashArray: 5,
    },
    tooltip: {
      enabled: true,
      shared: true,
      y: {
        formatter: function (val) {
          return `$${val.toFixed(1)}`;
        },
      },
    },
    markers: {
      size: 5,
      colors: ["#34B3F1", "#292D30", "#143A62"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    legend: {
      show: false,
    },
  });

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default MultilineChart;
